<script setup>
defineProps({
  isCameraReady: Boolean,
  version: String
});
</script>

<template>
<div
  class="fixed right-0 bottom-0 left-0 z-[99997] flex bg-white px-2 py-1 text-[10px] leading-normal font-light text-[#222]"
  :class="[!isCameraReady ? 'bg-[var(--background)] !text-[var(--text)]' : '']"
>
  <div class="flex-1">
    {{ $t("powered") }}
  </div>
  <div>
    v{{ version }}
  </div>
</div>
</template>
